module.exports = __webpack_public_path__ + "img/ring_r_c_1_null@3x.b8fcb121.png";